import React from "react";

const IrEmptyState = ({ message }) => {
  return (
    <div className="ir-empty-state">
      <svg
        width="40"
        height="40"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7 3.5h7l4 4V20a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1Z"
        />
        <path strokeLinecap="round" strokeLinejoin="round" d="M14 3.5V8h4" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 13h6M9 16.5h6" />
      </svg>
      <p>{message}</p>
    </div>
  );
};

export default IrEmptyState;
